/**
 * Console Guard - Strips verbose logging in production.
 * 
 * PERFORMANCE IMPACT:
 * - Eliminates thousands of console.log calls per session
 * - Reduces string allocations and GC pressure
 * - Keeps console.error and console.warn for critical issues
 */

const isProduction = import.meta.env.PROD || 
  (typeof window !== 'undefined' && window.location.hostname !== 'localhost');

if (isProduction) {
  const noop = () => {};
  
  // Suppress verbose logs in production
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  // Keep console.warn and console.error for real issues
}